import debounce from 'lodash.debounce';

export default {
  data() {
    return {
      activeSubMenus: [],
      isMobile: window.innerWidth <= 992,
      menuIsActive: false,
      subMenus: []
    };
  },
  computed: {
    facetsClasses() {
      const classes = {
        active: this.menuIsActive,
        initialized: this.isMobile
      };

      if (this.activeSubMenus.length > 0) {
        this.activeSubMenus.forEach((id) => {
          classes[`active-child-${id}`] = true;
        });
      }

      return classes;
    }
  },
  methods: {
    destroySubMenu(menu) {
      menu.removeEventListener('click', this.toggleMenu.bind(this, menu));
    },
    filterSubMenus(activeId) {
      this.activeSubMenus = this.activeSubMenus.filter(id => id !== activeId);
    },
    init() {
      if (!this.isMobile) return;

      this.subMenus = Array.from(document.querySelectorAll('#facets .facet'));
      this.subMenus.forEach(this.initSubMenu);
    },
    initSubMenu(menu) {
      menu.addEventListener('click', this.toggleMenu.bind(this, menu));
    },
    isInvalidToggle(e) {
      return e.target.matches('label') || e.target.matches('li');
    },
    toggleFilters() {
      this.menuIsActive = !this.menuIsActive;

      if (!this.menuIsActive) {
        this.activeSubMenus = [];
      }
    },
    toggleMenu(menu, e) {
      if (this.isInvalidToggle(e)) return;

      const activeId = parseInt(menu.dataset.id) + 1;

      if (this.activeSubMenus.includes(activeId)) {
        this.filterSubMenus(activeId);
        return;
      }

      this.activeSubMenus.push(activeId);
    }
  },
  watch: {
    activeSubMenus() {
      this.setClearButtonState();
    }
  },
  mounted() {
    window.addEventListener('resize', debounce(this.init, 500));
    window.addEventListener('facetsRendered', this.init);
  },
  destroyed() {
    // Remove all event listeners we created
    window.removeEventListener('resize', debounce(this.init, 500));
    window.removeEventListener('facetsRendered', this.init);
    this.subMenus.forEach(this.destroySubMenu);
  }
};
